import {
  ContractorType,
  DriverAgeEnum,
  DriverExperienceEnum
} from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const DriverInfo = () => {
  const { t } = useTranslation()
  const {
    driverAgeProps,
    driverExperienceProps,
    driversProps,
    contractorProps,
    fiftyFiftyFullProps
  } = formProps(t)
  const { required } = useValidationsField()
  const { isEditable } = useCascoInsuranceValues()

  const drivers = Form.useWatch(driversProps.name, { preserve: true })
  const contractor = Form.useWatch(contractorProps.name, { preserve: true })
  const fiftyFiftyFull = Form.useWatch(fiftyFiftyFullProps.name, {
    preserve: true
  })

  const optionsDriverAge = Object.values(DriverAgeEnum).map((value) => ({
    label: t(value),
    value,
    colProps: { xs: 24, lg: 12 }
  }))

  const optionsDriverExperience = Object.values(DriverExperienceEnum).map(
    (value) => ({ label: t(value), value, colProps: { xs: 24, lg: 12 } })
  )

  const disabledRadioGroup =
    contractor?.content_type === ContractorType.PERSON ||
    !!drivers?.length ||
    fiftyFiftyFull

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <Form.Item {...driverAgeProps} rules={[required]}>
          <RadioCardGroup
            disabled={disabledRadioGroup || isEditable}
            options={optionsDriverAge}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item {...driverExperienceProps} rules={[required]}>
          <RadioCardGroup
            disabled={disabledRadioGroup || isEditable}
            options={optionsDriverExperience}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
